<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-header">
    <div class= "page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-header-title">
        <%= I18n.t("apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.overview.graph.price_per_square_foot") %>
    </div>
</div>
<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content">
    <div style="color: <%= main_symbol_color %>; margin-right: 4px;"> <%= main_symbol %> </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content-label">
        <%= main_date_label %>:
    </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content-value">
        <%= main_value %>
    </div>
</div>
<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-header">
    <div class= "page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-header-title">
        <%= economic_indicator_title %>
    </div>
</div>
<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content">
    <div style="color: <%= compared_symbol_color %>; margin-right: 4px;"> <%= compared_symbol %> </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content-label">
        <%= compared_date_label %>:
    </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--line-graph-tooltip-point-content-value">
        <%= compared_value %>
    </div>
</div>
